import 'core-js/es6/map'
import 'core-js/es6/set'

import React, { Component } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { setAuthStatus, unauthenticate, storeUser, authenticate, storeBearerToken, setShowCaveonIdModal } from './js/actions/actions'
// UI
import css from './scss/App.scss'

// UI
import './scss/global.scss'
import './css/pure.css'

// Components

import Home from './js/components/Home'
import Header from './js/components/Header'
import Footer from './js/components/Footer'
import Items from './js/components/Items'
import Login from './js/components/Login'
import Item from './js/components/Item'
import NotFound from './js/components/NotFound'
import AccessTokens from './js/components/AccessTokens'
import Unauthorized from './js/components/Unauthorized'
import Variations from './js/components/Variations'
import DataSources from './js/components/DataSources'
import DataSource from './js/components/DataSource'
import Modal from './js/components/Modal'

import { throttle } from 'lodash'
import jwt_decode from 'jwt-decode'

export class App extends Component {
  constructor (props) {
    super()
    this.state = {
      user: {},
      caveonIdUrl: '',
      caveonIdOrigin: '',
      lockModal: false
    }
    this.addFetchInterceptor()
    this.INTERCEPTOR_WHITE_LIST = ['/api/v1/users/login', '/api/v1/users/refresh', '/api/v1/users/me']
    this.accessToken = ''
  }

  timer = () => {
    return new Promise((resolve) => setTimeout(resolve, 1000))
  }

  tokenIsValid = (token) => {
    try {
      const decoded = jwt_decode(token)
      return Date.now() < decoded.exp * 1000
    } catch (error) {
      return false
    }
  }

  addFetchInterceptor = () => {
    (function (self) {
      const originalFetch = fetch
      fetch = function () { // eslint-disable-line no-global-assign
        const [ resource, config ] = arguments

        return new Promise((resolve) => {
          const tokenIsValid = self.tokenIsValid(self.accessToken)

          if (!self.accessToken || tokenIsValid) return resolve()

          const caveonIdFrame = document.getElementById('caveonid-frame')

          const payload = {
            type: 'refresh_access_token',
            client: 'smart items'
          }

          if (caveonIdFrame && caveonIdFrame.contentWindow && self.state.caveonIdUrl) {
            caveonIdFrame.contentWindow.postMessage(payload, self.state.caveonIdUrl)
          }

          let attempt

          self.timer().then(() => {
            config.headers.Authorization = 'Bearer ' + self.accessToken

            attempt = self.tokenIsValid(self.accessToken)

            if (attempt) resolve()

            else self.timer().then(() => {
              config.headers.Authorization = 'Bearer ' + self.accessToken

              attempt = self.tokenIsValid(self.accessToken)

              if (attempt) resolve()

              else self.timer().then(() => {
                config.headers.Authorization = 'Bearer ' + self.accessToken

                attempt = self.tokenIsValid(self.accessToken)

                if (attempt) resolve()

                else self.timer().then(() => {
                  config.headers.Authorization = 'Bearer ' + self.accessToken

                  attempt = self.tokenIsValid(self.accessToken)

                  if (attempt) resolve()

                  else self.timer().then(() => {
                    config.headers.Authorization = 'Bearer ' + self.accessToken

                    resolve()
                  })
                })
              })
            })
          })
        })
        .then(() => {
          return originalFetch(resource, config).then(function (res) {
            if (res.status === 403) {
              const url = res.url
              for (let i = 0, len = self.INTERCEPTOR_WHITE_LIST.length; i < len; i++) {
                if (url.indexOf(self.INTERCEPTOR_WHITE_LIST[i]) === -1) {
                  self.props.dispatch(unauthenticate())
                  self.props.dispatch(setAuthStatus('unauthorized'))
                }
              }
            }
            return res
          })
        })
      }
    })(this)
  }

  componentDidMount () {
    window.addEventListener('message', this.onMessage, false)
    this.getCaveonIdUrl()
  }

  onMessage = event => {
    if (event.origin !== this.state.caveonIdOrigin) return

    switch (event.data.type) {
      case 'caveonid_access_token':
        this.onAccessToken(event.data.accessToken)
        break
      case 'logout':
        this.onLogout()
        break
      case 'caveonid_close_modal':
        this.onModal(false)
        break
      case 'caveonid_open_modal':
        this.onModal(true)
        break
      case 'caveonid_lock_modal':
        this.onLockModal()
        break
      case 'caveonid_unlock_modal':
        this.onUnlockModal()
        break
      default:
        break
    }
  }

  onAccessToken = accessToken => {
    if (accessToken) {
      this.accessToken = accessToken

      this.props.dispatch(storeBearerToken(accessToken))

      if (this.props.auth.authStatus !== 'authenticated') {
        this.getMe(accessToken)
      }

      return
    }

    this.props.dispatch(setAuthStatus('unauthenticated'))
  }

  onLogout = () => {
    window.location.replace('/')
  }

  onModal = (showModal) => {
    this.props.dispatch(setShowCaveonIdModal(showModal))
  }

  onLockModal = () => {
    this.setState({ lockModal: true }, () => this.onModal(true))
  }

  onUnlockModal = () => {
    this.setState({ lockModal: false }, () => this.onModal(false))
  }

  getMe = (accessToken) => {
    this.props.dispatch(setAuthStatus('undecided'))

    fetch('/api/v1/users/me', {
      method: 'GET',
      headers: {
        authorization: `Bearer ${accessToken}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      } else {
        this.props.dispatch(setAuthStatus('unauthenticated'))
        return { _error: res.statusText }
      }
    }).then(user => {
      if (user._error) {
        console.error('ERROR', user)
        this.props.dispatch(setAuthStatus('unauthenticated'))
      } else {
        if (user.name) {
          this.props.dispatch(storeUser(user))
        }
        this.props.dispatch(authenticate())
        this.props.dispatch(setAuthStatus('authenticated'))
      }
    })
  }

  getCaveonIdUrl = () => {
    fetch('/api/v1/caveonid_url', { method: 'GET' })
    .then(res => res.json())
    .then(data => {
      this.setState({ caveonIdUrl: data.url, caveonIdOrigin: new URL(data.url).origin }, () => {
        this.registerListeners()
      })
    })
  }
  
  registerListeners = () => {
    this.throttled = throttle(this.updateLastActivity, 5000)

    window.onmousemove = this.throttled
    window.onmousedown = this.throttled
    window.ontouchstart = this.throttled
    window.onclick = this.throttled
    window.onkeydown = this.throttled
    window.addEventListener('scroll', this.throttled, true)
  }

  updateLastActivity = () => {
    const caveonIdFrame = document.getElementById('caveonid-frame')

    const payload = {
      type: 'caveonid_activity',
      client: 'smart items'
    }

    caveonIdFrame.contentWindow.postMessage(payload, this.state.caveonIdUrl)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.auth.authenticated && this.props.auth.authenticated === false) {
      this.props.dispatch(setAuthStatus('authenticated'))
    }
  }

  render () {
    const { caveonIdUrl, lockModal } = this.state
    const authStatus = this.props.auth.authStatus
    let page = null
    switch (authStatus) {
      case 'authenticated' :
        page = (
          <article className={css.component}>
            <Switch>
              <Route exact path='/' component={Items} />
              <Route exact path='/login' component={Login} />
              <Route exact path='/items' component={Items} />
              <Route exact path='/item' component={Item} />
              <Route exact path='/item/:itemId' component={Item} />
              <Route exact path='/access' component={AccessTokens} />
              <Route exact path='/variations/:itemId' component={Variations} />
              <Route exact path='/data' component={DataSources} />
              <Route exact path='/data/:dataSourceId' component={DataSource} />
              <Route component={NotFound} />
            </Switch>
          </article>
        )
        break
      case 'unauthenticated':
        page = (
          <article className={css.component}>
            <Home />
          </article>
        )
        break
      case 'undecided' :
        page = (
          <article className={css.component}>
            <div className={css.loading}> Loading...</div>
          </article>
        )
        break
      case 'uninitiated' :
        page = (
          <article className={css.component}>
            <div className={css.loading}> Loading...</div>
          </article>
        )
        break
      case 'unauthorized':
        page = (
          <Unauthorized hideLogin />
        )
        break
      default:
        page = (
          <article className={css.component}>
            <div>NO CASE FOUND</div>
          </article>
        )
        break
    }
    return (
      <section className={css.wrapper}>
        <Modal caveonIdUrl={ caveonIdUrl } lockModal={ lockModal } />

        <Header />

        {page}
        <Footer />
      </section>
    )
  }
}
const mapStateToProps = state => {
  const { auth, app } = state
  return {
    auth,
    app
  }
}
export default withRouter(connect(mapStateToProps)(App))



// WEBPACK FOOTER //
// /app/App.js